import type { RootState } from "types";

export const getTopicsFilterSelectedIds = (state: RootState) => state.domains.filters.topics.selectedIds;
